import type { FC } from 'react';
import React from 'react';

import type { TIncreaseDecreaseInput } from './models';

export const IncreaseDecreaseInputMask: FC<TIncreaseDecreaseInput> = ({
    IncreaseDecreaseInput,
    MaskInput,
    ...rest
}) => <IncreaseDecreaseInput {...rest} InputComponent={MaskInput} />;
